function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.27 8.76c0 1.02-.47 1.94-1.23 2.54a3.2 3.2 0 01-2.03.72c-1.79 0-3.25-1.46-3.25-3.25 0-.89.36-1.7.96-2.29v-.01c.59-.59 1.4-.96 2.29-.96 1.8 0 3.26 1.46 3.26 3.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.18 18.73c-1.05.96-2.4 1.49-3.83 1.49H5.97c-2.74-.2-3.96-2.31-3.96-4.19 0-1.68.97-3.54 3.1-4.06-.93-3.58.85-6.08 2.93-7.27 2.06-1.17 4.96-1.36 7.14.25-.19.14-.36.29-.53.46l-.43.45v.06c-.62.81-.96 1.8-.96 2.84 0 2.62 2.14 4.75 4.76 4.75 1.08 0 2.13-.37 2.95-1.04.15-.12.3-.25.43-.39.99 2.08.85 4.84-1.22 6.65z"
})));